/**
 * @module Widget
 */

import { Component, Input, ViewChild } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';
import { HelperDateFormatComponent } from '@components/helpers/helper-date-format/helper-date-format.component';

@Component({
  selector: 'app-widget-layers-date-format',
  templateUrl: './widget-layers-date-format.component.html',
  styleUrls: ['./widget-layers-date-format.component.css']
})
export class WidgetLayersDateFormatComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;
  @ViewChild('dateFormatHelper', { static: true }) dateFormatHelper: HelperDateFormatComponent;

  color = ItemColor('widgets');

  timeout: any;

  constructor() {}

  receiveValue(value: string) {
    if(this.timeout !== undefined) clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.widgetLayers.layer(this.current).change({ dateFormat: value });
    }, 250);
  }

}
